import { render, staticRenderFns } from "./colgin-cellars.vue?vue&type=template&id=c19fadf2&scoped=true"
import script from "./colgin-cellars.vue?vue&type=script&lang=js"
export * from "./colgin-cellars.vue?vue&type=script&lang=js"
import style0 from "./colgin-cellars.vue?vue&type=style&index=0&id=c19fadf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19fadf2",
  null
  
)

export default component.exports